import { useStoryContext } from "../context/StoryContext";
import useStoryDetails from "./useStoryDetails";
import useStoryCharacters from "./useStoryCharacters";
import useStorySentences from "./useStorySentences";
import useStoryAssets from "./useStoryAssets";
import useStoryActors from "./useStoryActors";

export default function useStoryEditor(navigate) {
  const context = useStoryContext();

  const storyDetails = useStoryDetails({
    ...context,
    navigate,
  });

  const {
    setPublishClicked,
  } = context;

  const storyCharacters = useStoryCharacters({
    ...context,
  });

  const storySentences = useStorySentences({
    ...context,
    selectedCharacters:
      context.selectedCharacters,
  });

  const storyAssets = useStoryAssets({
    ...context,
  });

  const storyActors = useStoryActors();

  const publishStory = async () => {

    // save story first
    const responseStoryId =
      await storyDetails.saveStory();

    if (!responseStoryId) {
      return;
    }
    else{
      setPublishClicked(true);
    }

    // delete removed chars
    await storyCharacters.deleteCharactersFromDB();

    // save chars
    const characterMapping =
      await storyCharacters.saveCharacters(
        context.selectedCharacters,
        responseStoryId,
        context.mode
      );

    console.log("characterMapping", characterMapping);

    //----------------------------------
    // 4 Delete removed sentences
    //----------------------------------

    await storySentences.deleteSentencesFromDB();

    //----------------------------------
    // 5 Save sentences
    //----------------------------------

    await storySentences.saveSentences(
      context.selectedSentences,
      responseStoryId,
      characterMapping,
      context.mode
    );

    //----------------------------------
    // 6 Save assets
    //----------------------------------

   
    await storyAssets.compileAssets(responseStoryId);


    navigate("/storyEditor", {
      state: {
        storyId: responseStoryId,
        mode: "edit",
      },
    });
  };

  return {
    ...context,
    ...storyDetails,
    ...storyCharacters,
    ...storySentences,
    ...storyAssets,
    ...storyActors,

    publishStory,
  };
}